type LogCategory =
  | "AUTH"
  | "CHECKOUT"
  | "DATA"
  | "SAVE"
  | "UI"
  | "TIMER"
  | "WEBHOOK"
  | "NAVIGATION"
  | "VALIDATION"
  | "CRISIS"
  | "TRIAGEM"
  | "PROGRESS"
  | "SERVICE"
  | "PUSH"
  | "WHATSAPP"
  | "MICRODESAFIOS"
  | "FUNNEL"
  | "CONVERSAO"
  | "STRIPE"
  | "NPS"
  | "EXPORT"
  | "SYSTEM";

const isDev = import.meta.env.DEV || import.meta.env.MODE === "development";

function print(method: "info" | "warn" | "error" | "debug", category: LogCategory, message: string, payload?: unknown) {
  if (!isDev && method !== "error") return;

  const text = `[${category}] ${message}`;
  if (payload === undefined) {
    console[method](text);
  } else {
    console[method](text, payload);
  }
}

export const logger = {
  info: (category: LogCategory, message: string, payload?: unknown) => print("info", category, message, payload),
  warn: (category: LogCategory, message: string, payload?: unknown) => print("warn", category, message, payload),
  error: (category: LogCategory, message: string, payload?: unknown) => print("error", category, message, payload),
  debug: (category: LogCategory, message: string, payload?: unknown) => print("debug", category, message, payload),
  success: (category: LogCategory, message: string, payload?: unknown) => print("info", category, message, payload),
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
};
